import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { COLORS } from "../../Constants/colors";
import {
  SubHeading,
  ParagraphLg as Paragraph,
  Divider,
} from "../../Constants/typography";

const Container = styled.div`
  background: ${COLORS.secondary}10;
  border-radius: 32px;
  padding: 30px 40px;
  margin-bottom: 40px;
  box-sizing: border-box;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    padding: 30px 20px;
    margin-bottom: 20px;
  }
`;

const ContentWrapper = styled.div`
  margin: 0 auto;
`;

const MotionParagraph = styled(motion(Paragraph))`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.8;
  text-align: left;
  color: ${COLORS.textPrimary};

  @media screen and (max-width: 768px) {
    font-size: 18px;
    line-height: 1.6;
  }
`;

const OurMission = () => {
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const textAnimation = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0, transition: { duration: 1.2 } },
  };

  return (
    <Container ref={ref}>
      <ContentWrapper>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <SubHeading>MISSION</SubHeading>
          <Divider />
        </motion.div>

        <MotionParagraph
          variants={textAnimation}
          initial="initial"
          animate={inView ? "animate" : "initial"}
        >
          Our commitment to excellence, integrity, and continuous improvement
          ensures that we deliver reliable and high-quality software solutions
          that exceed expectations.
        </MotionParagraph>
      </ContentWrapper>
    </Container>
  );
};

export default OurMission;
